import angular from 'angular';
import pqrsListComponent from './pqrs-list.component';
import PqrsListService from './pqrs-list.service';
import pqrsListConfig from './pqrs-list.config';

let pqrsListModule = angular.module('app.pqrsList',[])
  .component('pqrsList', pqrsListComponent)
  .service('PqrsListService', PqrsListService)
  .config(pqrsListConfig);

export default pqrsListModule;



/** WEBPACK FOOTER **
 ** ./www/components/pqrs/pqrs-list/pqrs-list.js
 **/